import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Popper } from 'react-popper';


const Popover = ({ placement: popperPlacement, children, className, ...rest }) => {
	const blockClasses = classNames([
		'rounded',
		'bg-white',
		'scrollbar-blue',
		'text-black',
		'overflow-y-auto',
		'max-h-64',
		'w-40',
		'z-50',
		'max-w-40',
		className
	]);

	const modifiers = {
		preventOverflow: {
			enabled: true,
			boundariesElement: 'scrollParent'
		}
	};

	return (
		<Popper
			positionFixed
			modifiers={modifiers}
			placement={popperPlacement}
			{...rest}>
			{({ ref, style, placement }) => (
				<div
					ref={ref}
					style={style}
					className={blockClasses}
					data-placement={placement}>
					{ children }
				</div>
			)}
		</Popper>
	);
};

Popover.propTypes = {
	placement: PropTypes.string,
	className: PropTypes.string,
	children: PropTypes.node.isRequired
};
Popover.defaultProps = {
	className: '',
	placement: 'left-start'
};

export default Popover;
